var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColoredDustIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "colored-dust-icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.376,
    height: 23.099,
    viewBox: "0 0 17.376 23.099",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2098",
    "data-name": "Rectangle 2098",
    width: 17.376,
    height: 23.099,
    fill: "#caccb5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1926",
    "data-name": "Group 1926",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M9.442,21.481V23.1H5.285V21.586H0V1.762H5.255V0H9.427c0,.523.016,1.036,0,1.53-.016.278.092.34.34.386a8.275,8.275,0,0,1,6.027,3.632,9.822,9.822,0,0,1,1.482,4.513,13.283,13.283,0,0,1-.7,6.166,8.054,8.054,0,0,1-6.289,5.1c-.276.062-.538.108-.847.155m-5.3-3.245c1.406,0,2.782.108,4.126-.016a4.735,4.735,0,0,0,4.481-3.8,10.67,10.67,0,0,0,.046-5.269A4.777,4.777,0,0,0,8.1,5.116C6.8,5.024,5.5,5.085,4.2,5.07c-.016,0-.031.016-.078.046.017,4.358.017,8.744.017,13.12",
    transform: "translate(0 0)",
    fill: "#caccb5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredDustIcon);
export default __webpack_public_path__ + "static/media/colored-dust-icon.6ef0eb8131ccfb14de1ba035b321e575.svg";
export { ForwardRef as ReactComponent };